__turbopack_context__.v({
  "body_mobile": "hero-section-module-scss-module__VLbI8a__body_mobile",
  "container": "hero-section-module-scss-module__VLbI8a__container",
  "container_mobile": "hero-section-module-scss-module__VLbI8a__container_mobile",
  "cta_section_mobile": "hero-section-module-scss-module__VLbI8a__cta_section_mobile",
  "headline": "hero-section-module-scss-module__VLbI8a__headline",
  "headline_mobile": "hero-section-module-scss-module__VLbI8a__headline_mobile",
  "item_mobile": "hero-section-module-scss-module__VLbI8a__item_mobile",
});
